import { Validations } from "../../config";
import * as yup from "yup";

export const contactUsSchema = yup.object().shape({
  message: Validations.message,
});
